
import { motion } from 'framer-motion';
import FortuneCookie from '../FortuneCookie';
import FortuneTimer from '../FortuneTimer';
import RefreshButton from '../RefreshButton';

interface FortuneMainContentProps {
  canUseFortune: boolean;
  nextFortuneTime: string;
  onOpenCookie: () => void;
  onRefresh: () => void;
}

const FortuneMainContent = ({
  canUseFortune,
  nextFortuneTime,
  onOpenCookie,
  onRefresh
}: FortuneMainContentProps) => {
  return (
    <motion.div 
      className="flex flex-col items-center justify-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <FortuneCookie onClick={onOpenCookie} disabled={!canUseFortune && nextFortuneTime !== 'now'} />
      
      {!canUseFortune && (
        <FortuneTimer nextFortuneTime={nextFortuneTime} />
      )}
      
      {!canUseFortune && (
        <RefreshButton onClick={onRefresh} />
      )}
    </motion.div>
  );
};

export default FortuneMainContent;
